import Vue from 'vue';
import Vuex from 'vuex';
import modules from './modules';
//import errorBagPlugin from './plugins/errorBagPlugin';

Vue.use(Vuex);



const getters = {

    hasError(state) {
        return function(key) {
            if (typeof state.errors[key] !== 'undefined') return true;
            return false;
        }
    },

    getError(state) {
        return function(key) {
            if (typeof state.errors[key] !== 'undefined') return state.errors[key];
        }
    }

    // getFlashMessage: state => {
    //   return variant => state[variant];
    // },
    // flashed: state => {
    //   return Object.keys(state).filter(key => state[key] !== null).length === 0;
    // },
    // getErrors: function() {
    //  //
    // }
};
const mutations = {


    putErrorMessages(state, error)
    {
        state.errors = {};

        var error_names = [];
        var errors      = _.get(error, 'response.data.errors', []);
        var status_code = _.get(error, 'response.status', 500);

        if (status_code == 500) {
            state.errors.error = 'We have a problem on our server. Please try again later.';
            return;
        } 

        if (status_code == 422) {
            if (errors.length < 1) {
                state.errors.error = 'Invalid input.';
                return;
            }

            for (let i = 0; i < errors.length; i++) {
                let e = errors[i];

                if (typeof e.meta.input !== 'undefined') {

                    let error_key = null;
                    if (e.meta.input.match(/\.\d\./i)) {
                        error_key = e.meta.input.replace(/\.(\d)\./i, "[$1].");
                    } else {
                        error_key = e.meta.input;
                    }
                    state.errors[error_key] = e.detail;

                    let key = null;                
                    key = e.meta.input.replace(/\./i, '_');

                    error_names.push(key);
                } else {
                    // some other server error
                    state.errors.error = e.detail ? e.detail : null;
                }

            }

        }


        handleSubmitFail(error_names);
    },

    applyUnsetError(state, key)
    {
        if (typeof state.errors[key] !== 'undefined') {
            delete state.errors[key];
        }
    },

    applyResetErrors(state)
    {
        state.errors = {};
    }
};



const actions = {
    putErrors(context, errors) {
        context.commit('putErrorMessages', errors);
    },
    unsetError(context, key) {
        context.commit('applyUnsetError', key);
    },
    resetErrors(context) {
        context.commit('applyResetErrors');
    }
};



export default new Vuex.Store({
	strict: true,
	modules: modules,

	mutations: mutations,
	actions: actions,
	getters: getters,
	// plugins: [
	// 	errorBagPlugin
	// ]
});



